<template>
	<div>
		<ul class="integration-list">
			<li
				class="integration-list__item"
				:key="item.id"
				:id="`${uid}_${item.id}`"
				v-for="item in items"
			>
				<SiteBodCard :source="item" @remove="removeSiteBod" />
			</li>
		</ul>
		<Modals
			v-model="displayConfirmationModal"
			type="confirmation"
			:title="confirmationModalTile"
			ref="confirmationDialogue"
		/>
	</div>
</template>

<script>
import Modals from '@/components/shells/modal/modals';
import SiteBodCard from './sitebod-card.vue';
//constants
import {
	MODULE_NAME,
	REMOVE_SITEBOD
} from '@/sections/integration/integrations-mutation-types';

export default {
	name: 'SiteBodList',
	components: {
		Modals,
		SiteBodCard
	},
	props: {
		items: {
			type: Array
		}
	},
	data() {
		return {
			displayConfirmationModal: false,
			confirmationModalTile: null
		};
	},
	methods: {
		async removeSiteBod(siteBod) {
			this.confirmationModalTile = `Are you sure you want to remove the
				${siteBod?.bodType} ${siteBod?.bodVersion} SiteBOD?`;

			this.displayConfirmationModal = true;

			if (await this.$refs.confirmationDialogue.confirm()) {
				this.$store.dispatch(
					`${MODULE_NAME}/${REMOVE_SITEBOD}`,
					siteBod
				);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * Results List
    * Can use SCSS variables = TRUE
	* [Table of Contents]
    *
    * BASE
    * BASE DESKTOP-UP
*/

/*------------------------------------*\
  #BASE
\*------------------------------------*/

.integration-list {
	list-style: none;
	padding: 0;
	overflow-y: auto;
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
	grid-template-rows: auto;
	gap: 12px;
	align-content: start;
}

/*------------------------------------*\
  #BASE DESKTOP-UP
\*------------------------------------*/
@include mq($from: lg) {
	.integration-list {
		grid-template-columns: 1fr 1fr;
	}
}
</style>
